module.exports = __webpack_public_path__ + "267736c7d72ec5f33ffa627c4ff24d9f.gif";